import { FaLinkedinIn, FaFacebookF, FaTwitter } from 'react-icons/fa';
import styles from './SocialShare.module.scss';

/**
 * @param            props
 * @param            props.url
 * @param            props.title
 * @return {Element}             social element
 */
export default function SocialShare({ url, title }) {
  return (
    <ul className={styles.social_share}>
      <li className={styles.social_share_item}>
        <a
          className={styles.social_share_icon}
          href={`https://twitter.com/share?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`}
          target="_blank"
        >
          <FaTwitter />
        </a>
      </li>
      <li className={styles.social_share_item}>
        <a
          className={styles.social_share_icon}
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
          target="_blank"
        >
          <FaFacebookF />
        </a>
      </li>
      <li className={styles.social_share_item}>
        <a
          className={styles.social_share_icon}
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`}
          target="_blank"
        >
          <FaLinkedinIn />
        </a>
      </li>
    </ul>
  );
}
